import * as React from 'react'

import { ProductBlock as GravityProductBlock } from '@thg-commerce/gravity-patterns'
import { ProductBlockProps as GravityProductBlockProps } from '@thg-commerce/gravity-patterns/ProductBlock/ProductBlock'

import { ProductPriceProps } from '@thg-commerce/gravity-elements'
import { useSiteConfig } from '@thg-commerce/enterprise-core'
import { QubitBadgeRenderer } from '@thg-commerce/enterprise-components/Qubit/QubitBadge/QubitBadgeRenderer'
import { QubitViewType } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/Qubit'
import { BreakpointArray, Orientation } from '@thg-commerce/gravity-theme'

import { useQuickBuyClickHandler } from './hooks'

export type ProductBlockProps = GravityProductBlockProps &
  ProductPrice & {
    sku: string
    button?: Omit<GravityProductBlockProps['button'], 'onClick'> & {
      quickBuyTitle: string
      productInStock?: boolean
    }
    fromRecommendations?: boolean
    onQuickBuyClickEventEmitter?: () => void
    quickBuyFeatureEnabled?: boolean
  }

interface ProductPrice {
  price?: ProductPriceProps
}

export const ProductBlock = (props: ProductBlockProps) => {
  return <EnterpriseProductBlock {...props} />
}

const EnterpriseProductBlock = React.memo((props: ProductBlockProps) => {
  const { quickBuyTitle: quickBuyButtonTitle, productInStock } = {
    ...props.button,
  }
  const quickBuyClickHandler = useQuickBuyClickHandler(
    props.sku,
    props.fromRecommendations,
  )

  const {
    showProductBlockBrandTitle,
    hideProductListSwatch,
    previewQuickbuy,
  } = useSiteConfig()

  const quickBuyEnabled = previewQuickbuy && productInStock

  const buttonClickHandler = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.stopPropagation()

    quickBuyClickHandler(event)
    props.onQuickBuyClickEventEmitter?.()
  }

  const QubitBadgeAnotation = ({ children }) => {
    const orientation: BreakpointArray<Orientation> = [
      Orientation.VERTICAL,
      Orientation.VERTICAL,
      Orientation.HORIZONTAL,
      Orientation.HORIZONTAL,
    ]

    return (
      <div id="placeholder" style={{ position: 'relative' }}>
        <QubitBadgeRenderer
          productId={props?.sku.toString()}
          type={QubitViewType.CATEGORY}
          orientation={orientation}
        />
        {children}
      </div>
    )
  }

  return (
    <GravityProductBlock
      {...props}
      image={props.image}
      showBrandTitle={showProductBlockBrandTitle}
      hideProductListSwatch={hideProductListSwatch}
      annotateImageComponent={QubitBadgeAnotation}
      button={
        props.button && {
          ...props.button,
          title:
            quickBuyEnabled && quickBuyButtonTitle
              ? quickBuyButtonTitle
              : props.button.title,
          onClick: quickBuyEnabled ? buttonClickHandler : undefined,
        }
      }
    />
  )
})
